import React from "react";
import { css } from "@emotion/css";
import { GoQuestion } from "react-icons/go";
import { SectionCard } from "../../../../shared/ui/section-card/section-card";
import { SectionTitle } from "../../../../shared/ui/section-title/section-title";

export interface EventMapCardProps extends React.HTMLAttributes<HTMLDivElement> {
  theaterName: string;
  theaterAddress: string;
}

const sectionHeader = css({
  display: "flex",
  alignItems: "center",
  gap: "var(--spacing-sm)",
  marginBottom: "var(--spacing-lg)",
  position: "relative",
  paddingLeft: "var(--spacing-sm)",
});

const sectionIcon = css({
  color: "var(--pc-700)",
  minWidth: "20px",
  width: "20px",
  height: "20px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
});

const locationContent = css({
  display: "flex",
  flexDirection: "column",
  gap: "1.5rem",
  paddingLeft: "var(--spacing-md)",
  paddingRight: "var(--spacing-md)",
  
  "@media (max-width: 768px)": {
    paddingLeft: "var(--spacing-sm)",
    paddingRight: "var(--spacing-sm)",
  },
});

const locationInfo = css({
  "& h3": {
    fontSize: "1.125rem",
    fontWeight: 600,
    color: "var(--pc-700)",
    marginBottom: "0.5rem",
    
    "@media (max-width: 768px)": {
      fontSize: "var(--fs-400)",
    },
    
    "@media (max-width: 480px)": {
      fontSize: "var(--fs-350)",
    },
  },
  
  "& p": {
    fontSize: "1rem",
    lineHeight: 1.6,
    color: "var(--g-700)",
    marginBottom: "1rem",
    
    "@media (max-width: 48rem)": {
      fontSize: "0.9375rem",
    },
    
    "@media (max-width: 30rem)": {
      fontSize: "0.875rem",
    },
  },
});

const locationMap = css({
  width: "100%",
  height: "15.625rem",
  borderRadius: "var(--spacing-md)",
  overflow: "hidden",
  marginBottom: "1rem",
  border: "1px solid rgba(var(--pcrgba-200), 0.3)",
  
  "& iframe": {
    width: "100%",
    height: "100%",
    border: 0,
  },
});

export const EventMapCard: React.FC<EventMapCardProps> = ({
  theaterName,
  theaterAddress,
  className,
  ...rest
}) => {
  return (
    <SectionCard className={className} {...rest}>
      <div className={sectionHeader}>
        <GoQuestion className={sectionIcon} />
        <SectionTitle level={2}>Como chegar?</SectionTitle>
      </div>
      
      <div className={locationContent}>
        <div className={locationInfo}>
          <h3>{theaterName}</h3>
          <p>{theaterAddress}</p>
          
          <div className={locationMap}>
            <iframe 
              src={`https://maps.google.com/maps?&q=${encodeURIComponent(theaterAddress)}&output=embed`}
              allowFullScreen
              loading="lazy" 
              referrerPolicy="no-referrer-when-downgrade"
              title={`Mapa de localização - ${theaterName}`}
            />
          </div>
        </div>
      </div>
    </SectionCard>
  );
};

export default EventMapCard;
